import { useEffect, useState } from 'react'
import { camelCaseObjectKeys } from '@doordash/object-utils'
import { getIdvSessionToken } from '../api'
import { EventActions, IdentityVerificationPages } from '../typeModules/events'

/**
 * TODO @alexkim-doordash: properly type the hook
 */
type useSessionTokenOpts = {}

/**
 * TODO @alexkim-doordash: describe usage
 *
 * If not isEnabled, will just return an empty string
 */
export const useSessionToken = ({
  referenceId,
  inquiryId,
  onSessionTokenRetrieval,
  isEnabled,
}) => {
  const [sessionToken, setSessionToken] = useState('')

  useEffect(() => {
    const getSessionToken = async () => {
      const response = await getIdvSessionToken(referenceId, inquiryId)
      onSessionTokenRetrieval({
        status: EventActions.Success,
        step: IdentityVerificationPages.ResumeInquiry,
      })
      setSessionToken(camelCaseObjectKeys(response.data).sessionToken)
    }
    if (isEnabled) {
      getSessionToken()
    }
  }, [inquiryId, isEnabled, onSessionTokenRetrieval, referenceId])

  return sessionToken
}

export default useSessionToken
